<script setup>
import { to } from 'await-to-js';
import dayjs from 'dayjs';
import { Edit } from '@element-plus/icons-vue'
import { onMounted, ref } from "vue";
//import { useRouter } from "vue-router";
import { interceptor } from "@dutypay/utilities";
const createOSSCorrectionProjectForm = ref({});
const companiesList = ref([]);
const OSSCorrectionProjectsList = ref([]);

onMounted(async() => {
  await getOSSCorrectionProjects(); 
})

const getCompanies = async (query) => {
  const envStore = useEnvStore();
  if (query) {
    let err, res;
    [err, res] = await to(
      interceptor.get(`${envStore.apiUrls.dutypay  }/api/v0/my/companies/all`, {
          params: {
            search: query
          }
        }
      )
    );
    if (err) {
      console.log(err)
      companiesList.value = [];
    }
    companiesList.value = res.data.result.companies;
  }
}

const getOSSCorrectionProjects = async () => {
  const envStore = useEnvStore();
  let err, res;
    [err, res] = await to(
      interceptor.get(`${envStore.apiUrls.dutypay  }/api/v0/tools/oss-correction-projects`, {
          params: {
            
          }
        }
      )
    );
    if (err) {
      OSSCorrectionProjectsList.value = [];
      return;
    }
    OSSCorrectionProjectsList.value = res.data.result.OSSCorrectionProjects;
}

const onCreateOSSCorrectionProject = async () => {
  const envStore = useEnvStore();
  let err, res;
    [err, res] = await to(
      interceptor.post(`${envStore.apiUrls.dutypay  }/api/v0/tools/oss-correction-projects`,
        createOSSCorrectionProjectForm.value
      )
    );
    if (err){
      console.log(err);
      return;
    }
    await getOSSCorrectionProjects();
}
</script>

<script>
import { useEnvStore } from "@dutypay/store-modules";
//import { to } from "await-to-js";
import { mapState } from "pinia";
export default {
  name: "OSSCorrectionProjects",
  computed: {
    ...mapState(useEnvStore, ["apiUrls"]),
  },
  methods: {
    printError(err) {
      if (this.debug) {
        this.$dp.log(err);
      }
    },
    data() {
      return {
        OSSCorrectionProjects: [],
      };
    },
  },
};
</script>

<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <h1>OSS Correction Projects</h1>
        <el-form
          :inline="true"
          :model="createOSSCorrectionProjectForm"
          class="form-inline"
        >
          <el-form-item label="DutyPay Customer">
            <el-select
              v-model="createOSSCorrectionProjectForm['hs.company.id']"
              placeholder="Select DutyPay Customer"
              clearable
              filterable
              remote
              :remote-method="getCompanies"
            >
            <el-option
              v-for="item in companiesList"
              :key="item.hs.company.id"
              :label="item.name.legal"
              :value="item.hs.company.id"
            />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onCreateOSSCorrectionProject" :disabled="!createOSSCorrectionProjectForm['hs.company.id']">Create</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="OSSCorrectionProjectsList" style="width: 100%">
          <el-table-column label="Date" style="width: 10%">
            <template #default="scope">
            <div style="display: flex; align-items: center">
              {{ dayjs(scope.row['creation.startDate']).format('DD.MM.YYYY HH:mm:ss') }}
            </div>
            </template>
          </el-table-column>
          <el-table-column prop="property.value.en-US" label="Company" style="width: 50%"/>
          <el-table-column label="Actions" style="width:40%">
            <template #default="scope">
              <div style="display: flex; align-items: center">
                <el-button type="primary" :icon="Edit" @click="$router.push('/tools/oss-correction/' + scope.row['hs.oss.correction.project.id'])"></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <pre>
      
    </pre>
  </div>
</template>

<style scoped lang="scss">
.form-inline .el-input {
  --el-input-width: 220px;
}
</style>

<i18n>
  {
  "en-US": {
  }
  }
</i18n>
